/**
 * LLM Connector Services
 * Management surface for the remote MCP connector (grants, kill switches, audit log, clients).
 */
export { ConnectorService } from './ConnectorService';
import { ConnectorService } from './ConnectorService';
export function createConnectorServices(http, config) {
    return {
        connector: new ConnectorService(http, config),
    };
}
//# sourceMappingURL=index.js.map